<!--
本画面は、スマホ対応（2021.2Q）に伴い廃止
-->
<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form class="t-application-invite-user-form__form" @submit.prevent="handleSubmitForm">
      <div class="t-application-invite-user-form__fields">
        <a-radio v-model="radioValue" name="businessType" value="individual" label="個人名義のお申し込み" />
        <a-radio v-model="radioValue" name="businessType" value="company" label="法人名義のお申し込み" />
      </div>
      <div class="t-application-invite-user-form__buttons">
        <m-button-container>
          <a-button variant="block" submit="submit" color="primary" :disabled="!radioValue">次へ</a-button>
          <a-button color="primary" @click="handleCancelClick">戻る</a-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-modal
        id="applicationInviteUserSelect_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import { cloneDeep } from 'lodash';
import OModal from '@/components/organisms/modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { SIGNUP_RELIEF_MEASURES_PATH } from '@/libs/constants';

export default {
  name: 't-application-invite-user-form',
  components: {
    TDefaultEntrySidebar,
    AButton,
    MButtonContainer,
    OModal,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    errorList: {
      type: Object,
      default: null,
    },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      radioValue: false,
      // formData: {
      //   name: '',
      //   componay_name: '',
      //   phone_number: '',
      //   postal_code: '',
      //   street_address: '',
      //   email: '',
      //   password: '',
      //   password_confirm: '',
      // },
      /*
      formData: {
        lastname: this.$route.params.lastname,
        name: this.$route.params.name,
        lastname_kana: this.$route.params.lastname_kana,
        name_kana: this.$route.params.name_kana,
        year: this.$route.params.year,
        month: this.$route.params.month,
        day: this.$route.params.day,
        date: this.$route.params.date,
        company_name: this.$route.params.company_name,
        phone_number: this.$route.params.phone_number,
        postal_code: this.$route.params.postal_code,
        street_address: this.$route.params.street_address,
        email: this.$route.params.email,
        purpose: this.$route.params.purpose,
      },
*/
      sidebarInfo: {
        sidebarList: [
          { label: '契約名義種別の選択' },
          { label: '契約情報の入力・本人確認書類' },
          { label: '支払い情報の入力' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 1,
        heading: '契約名義種別の選択',
        subHeading: 'Step 1',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user-form');
      return `${baseClassName} ${this.class}`.trim();
    },
    hasError() {
      let isValid = true;
      if (this.errorList) {
        isValid = !Object.keys(this.errorList).length > 0;
      }
      return isValid;
    },
  },
  mounted() {
    const tmpCompanyID = this.getCookie('tmpUUID');
    if (tmpCompanyID.indexOf('tmp_') === -1) {
      this.$router.push({ path: SIGNUP_RELIEF_MEASURES_PATH });
      return; // #2314
    }

    this.fetchTmpDataHandler();
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSubmitForm(e) {
      e.preventDefault();
      /*
      const payload = cloneDeep(this.formData);
      this.handleFormSubmit(payload);
      */

      const tmpData = {
        businessType: this.radioValue,
      };

      this.postRequest('/signup/updateBusinessType', {
        tmpCompanyID: this.getCookie('tmpUUID'),
        tmpYMD: this.getCookie('tmpYMD'),
        validate: false,
        data: tmpData,
      })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('契約名義種別の選択'));
            } else {
              this.$router.push({ path: '/signup/form' });
            }
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約名義種別の選択'));
        });
    },
    getFieldError(key) {
      if (this.errorList && this.errorList[key]) {
        return this.errorList[key];
      }
      return null;
    },
    handleCancelClick() {
      this.$router.push({ path: SIGNUP_RELIEF_MEASURES_PATH });
    },
    getCookie(key) {
      const name = key + '=';
      const cookie = document.cookie;
      const cookieList = cookie.split(';');
      for (let i = 0; i < cookieList.length; i++) {
        let cookieItem = cookieList[i];
        while (cookieItem.charAt(0) === ' ') {
          cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
          return cookieItem.substring(name.length, cookieItem.length);
        }
      }
      return '';
    },
    fetchTmpDataHandler: async function () {
      await this.postRequest('/signup/getCollection', {
        tmpCompanyID: this.getCookie('tmpUUID'),
        tmpYMD: this.getCookie('tmpYMD'),
        collectionType: 'historyCollection',
      })
        .then(e => {
          if (e.session) {
            this.setCurrentValue(e.data);
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約名義種別の選択'));
        });
    },
    setCurrentValue(val) {
      this.radioValue = val.businessType || '';
    },
  },
};
</script>
